"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeUndefined = exports.objectAssign = undefined;

var _objectAssign2 = require("./object-assign");

var _objectAssign3 = _interopRequireDefault(_objectAssign2);

var _removeUndefined2 = require("./remove-undefined.js");

var _removeUndefined3 = _interopRequireDefault(_removeUndefined2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @fileoverview 对象相关
 * @author kirkzheng
 */

var objectAssign = exports.objectAssign = _objectAssign3.default;
var removeUndefined = exports.removeUndefined = _removeUndefined3.default;

exports.default = {
  objectAssign: objectAssign,
  removeUndefined: removeUndefined
};